import axios, { ResponseType } from "axios";
import humps from "humps";
import { isArray, isPlainObject } from "lodash";

const transformResponse = (data: any) =>
  isPlainObject(data) || isArray(data) ? humps.camelizeKeys(data) : data;

const defaultHttpSettings = {
  responseType: "json" as ResponseType,
  headers: {
    "ocp-apim-subscription-key":
      process.env.REACT_APP_OCP_APIM_SUBSCRIPTION_KEY,
    "Content-Type": "application/json",
  },
  transformResponse: (axios.defaults.transformResponse as Array<any>).concat(
    transformResponse
  ),
};

export const http = axios.create({
  ...defaultHttpSettings,
  baseURL: `${process.env.REACT_APP_API_URL}/`,
});
